(() => {
  const HIDDEN_CLASS = 'variant-section--hidden';
  let hideMap = {};
  let managedSections = new Set();
  const sectionCache = new Map();

  function normalizeKey(key) {
    return String(key || '').trim();
  }

  function findSections(key) {
    const value = normalizeKey(key);
    if (!value) return [];

    const sections = new Set();

    const addSection = (el) => {
      if (!el) return;
      const section = el.classList?.contains('shopify-section')
        ? el
        : el.closest?.('.shopify-section');
      if (section) sections.add(section);
    };

    if (value.startsWith('#') || value.startsWith('.') || value.startsWith('[')) {
      try {
        document.querySelectorAll(value).forEach(addSection);
      } catch (error) {
        console.warn('Invalid hide_sections selector:', value, error);
      }
      return [...sections];
    }

    const classes = value.split(/\s+/).filter(Boolean);
    const selector = classes.map((className) => `.${CSS.escape(className)}`).join('');

    try {
      document.querySelectorAll(selector).forEach(addSection);
      document.querySelectorAll(`[data-hide-section="${value}"]`).forEach(addSection);
      if (classes.length === 1) {
        document.querySelectorAll(`.shopify-section.${CSS.escape(classes[0])}`).forEach(addSection);
        document.querySelectorAll(`#shopify-section-${CSS.escape(classes[0])}`).forEach(addSection);
      }
    } catch (error) {
      console.warn('Failed to resolve hide_sections key:', value, error);
    }

    return [...sections];
  }

  function getSectionsForKey(key) {
    const normalized = normalizeKey(key);
    if (!sectionCache.has(normalized)) {
      sectionCache.set(normalized, findSections(normalized));
    }
    return sectionCache.get(normalized);
  }

  function warmupCache() {
    Object.values(hideMap).forEach((keys) => {
      (keys || []).forEach((key) => getSectionsForKey(key));
    });
  }

  function applyHideSections(keys) {
    managedSections.forEach((section) => {
      section.classList.remove(HIDDEN_CLASS);
    });
    managedSections = new Set();

    (keys || []).forEach((key) => {
      getSectionsForKey(key).forEach((section) => {
        section.classList.add(HIDDEN_CLASS);
        managedSections.add(section);
      });
    });
  }

  function applyForVariantId(variantId) {
    if (!variantId) {
      applyHideSections([]);
      return;
    }
    applyHideSections(hideMap[String(variantId)] || []);
  }

  function getSelectedOptions(variantSelects) {
    return Array.from(variantSelects.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') return element.value;
      return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
    });
  }

  function resolveVariantId(variantSelects) {
    const jsonNode = variantSelects.querySelector(':scope > [type="application/json"]');
    if (!jsonNode) return null;

    let variants;
    try {
      variants = JSON.parse(jsonNode.textContent);
    } catch (error) {
      return null;
    }

    const options = getSelectedOptions(variantSelects);
    const match = variants.find((variant) =>
      variant.options.every((option, index) => options[index] === option)
    );
    return match?.id || null;
  }

  function initFromJson() {
    const node = document.querySelector('[data-variant-hide-sections]');
    if (!node) return false;

    try {
      const data = JSON.parse(node.textContent);
      hideMap = data.map || {};
      sectionCache.clear();
      warmupCache();
      applyForVariantId(data.selectedId);
      return true;
    } catch (error) {
      console.error('Failed to parse variant hide sections data.', error);
      return false;
    }
  }

  function onVariantInputChange(event) {
    const target = event.target;
    if (!(target instanceof HTMLElement)) return;
    if (target.matches('input[type="radio"], select') === false) return;

    const variantSelects = target.closest('variant-selects');
    if (!variantSelects) return;

    const variantId = resolveVariantId(variantSelects);
    applyForVariantId(variantId);
  }

  function bindImmediateChange() {
    document.addEventListener('change', onVariantInputChange, true);
  }

  function init() {
    if (!initFromJson()) return;
    bindImmediateChange();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', () => {
    initFromJson();
  });
})();
